module.exports = __webpack_public_path__ + "static/media/intro-4.98f1e907.png";